import { render, staticRenderFns } from "./CreateAufnDialog.vue?vue&type=template&id=2a9528a2&scoped=true"
import script from "./CreateAufnDialog.vue?vue&type=script&lang=js"
export * from "./CreateAufnDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateAufnDialog.vue?vue&type=style&index=0&id=2a9528a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9528a2",
  null
  
)

export default component.exports